export default __webpack_public_path__ + "static/media/detail_big_1_1.87558f07.png";